import React, { useEffect, useState } from 'react'

import Message from '@Pure/Message'
import Link    from '@Pure/Link'

import request from '@function/ajax/request'

export default function EcRenewalWarning ({ ...props })
{
	const [renewal_status, setRenewalStatus] = useState();
	const [status, setStatus] = useState({ });

	useEffect(function ()
	{
		(async function ()
		{
			try
			{
				var { renewal_status } = await request('/EC-renewal/get-state')
				.config({ keyword: 'ressource' })
				.post({ });
			}
			catch (update)
			{
				return setStatus(update);
			}

			setRenewalStatus(renewal_status);
		})();
	},
	[]);

	if (document.location.pathname === '/accueil/renouvellement-CSE') return null;

	if (renewal_status !== 'pending_EC') return null;

	return (
		<Message color="orange" icon="info"
			className="u-margin-bottom-0 u-margin-top-0">
			Alerte importante&nbsp;: mise à jour de votre structure requise
			{ ' ' }
			<Link href="/accueil/renouvellement-CSE">
				Cliquez-ici pour accéder au formulaire
			</Link>
		</Message>
	);
}